import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import MangaCard from '@/components/feature/MangaCard';
import { categories, categoryMap } from '@/mocks/categories';
import { getMangaByCategory } from '@/mocks/manga';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'korean-romance');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const currentCategory = categoryMap[activeSlug];
  const mangaList = getMangaByCategory(activeSlug);

  useEffect(() => {
    if (currentCategory) {
      document.title = `${currentCategory.name} - 下拉式免费漫画阅读 - 亲亲漫画网`;
    }
  }, [currentCategory]);

  if (!currentCategory) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 text-center py-20">
          <p className="text-foreground-500">分类不存在</p>
        </div>
        <Footer />
      </div>
    );
  }

  const canonicalUrl = `https://yutuocq.cn/category/${activeSlug}`;

  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${currentCategory.name} - 亲亲漫画网`,
            description: currentCategory.description,
            url: canonicalUrl,
            isPartOf: {
              '@type': 'WebSite',
              name: '亲亲漫画网',
              url: 'https://yutuocq.cn',
            },
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: currentCategory.name },
          ]}
        />

        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-8">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              {currentCategory.name}
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              浏览全部<strong>{currentCategory.name}</strong>漫画，{currentCategory.description}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-8">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveSlug(cat.slug)}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 border border-background-200/60'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {mangaList.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
              {mangaList.map((manga) => (
                <MangaCard key={manga.id} manga={manga} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类暂无漫画，请浏览其他分类</p>
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}